import { render, staticRenderFns } from "./FixedPrice.vue?vue&type=template&id=bbf17126&"
import script from "./FixedPrice.vue?vue&type=script&lang=js&"
export * from "./FixedPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports